/* src/app/auth/components/recover-form/recover-form.component.scss */
:host {
  display: flex;
  justify-content: center;
}
.recover-form {
  width: 350px;
}
.recover-form .mat-form-field {
  width: 100%;
}
.login-type {
  position: relative;
  text-align: center;
  font-weight: bold;
}
.pseudo--selected {
  color: #000 !important;
}
.recover-form .phone-field-container {
  display: flex;
}
.recover-form .phone-field-container .prefix-field {
  width: 57px;
  margin-right: 5px;
}
.recover-form .hide-password-icon {
  cursor: pointer;
  position: relative;
  top: 0px;
  left: 3px;
}
.account-admin-method {
  text-align: center;
}
/*# sourceMappingURL=recover-form.component.css.map */
